// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.Breadcrumb_breadcrumbItem__x_rag.Breadcrumb_isBlue__m0LLh {\n  color: #8fa3fe !important; }\n  .Breadcrumb_breadcrumbItem__x_rag.Breadcrumb_isBlue__m0LLh > a {\n    color: #8fa3fe !important; }\n\n.Breadcrumb_breadcrumbItem__x_rag:not(.Breadcrumb_isBlue__m0LLh) {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  color: black;\n  cursor: default; }\n", ""]);
// Exports
exports.locals = {
	"breadcrumbItem": "Breadcrumb_breadcrumbItem__x_rag",
	"isBlue": "Breadcrumb_isBlue__m0LLh"
};
module.exports = exports;
